import { enums } from '../constants'

const normalizeStringForIdentifier = (value) => {
  if (!value) return ''
  return String(value)
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
}

export const getTipoBancoId = (tipoBanco) => {
  if (tipoBanco == null) return null
  if (typeof tipoBanco === 'number') return tipoBanco

  if (typeof tipoBanco === 'object') {
    if (tipoBanco.id != null) return tipoBanco.id
    if (tipoBanco.codigo != null) return tipoBanco.codigo
  }

  return null
}

export const findTipoBancoInLookup = (tipoBanco, lookup = enums.TipoBancoLookup) => {
  const id = getTipoBancoId(tipoBanco)
  if (id == null) return null
  return lookup.find((item) => item.id === id) || null
}

export const isTipoBancoInLookup = (tipoBanco, lookup = enums.TipoBancoLookup) => {
  return !!findTipoBancoInLookup(tipoBanco, lookup)
}

export const isObjectInTipoBancoList = (tipoBanco, list = enums.TipoBancoLookup) => {
  const id = getTipoBancoId(tipoBanco)
  if (id == null) return false
  return Array.isArray(list) && list.some((item) => item?.id === id)
}

export const isTipoBancoEqualToEnum = (tipoBanco, enumItem) => {
  const idA = getTipoBancoId(tipoBanco)
  const idB = getTipoBancoId(enumItem)
  if (idA == null || idB == null) return false
  return idA === idB
}

export const resolveTipoBancoFromLookup = (tipoBanco, lookup = enums.TipoBancoLookup) => {
  const resolved = findTipoBancoInLookup(tipoBanco, lookup)
  return resolved || tipoBanco
}

// Métodos diretos (um por item do enums.TipoBanco/TipoBancoLookup)
export const isTipoBancoBancoDoBrasil = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.BANCO_DO_BRASIL)
export const isTipoBancoSantander = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.SANTANDER)
export const isTipoBancoBanrisul = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.BANRISUL)
export const isTipoBancoAilos = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.AILOS)
export const isTipoBancoCaixa = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.CAIXA)
export const isTipoBancoBradesco = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.BRADESCO)
export const isTipoBancoItau = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.ITAU)
export const isTipoBancoSicredi = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.SICREDI)
export const isTipoBancoSicoob = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco.SICOOB)

// Opcional: mapa com guards gerados a partir do enum atual
export const TipoBancoGuards = Object.keys(enums.TipoBanco).reduce((acc, key) => {
  const base = normalizeStringForIdentifier(key)
  const pascal = base
    .toLowerCase()
    .replace(/(?:^|\s)(\w)/g, (_, c) => c.toUpperCase())
    .replace(/\s+/g, '')

  const methodName = `isTipoBanco${pascal}`
  if (!methodName || acc[methodName]) return acc

  acc[methodName] = (tipoBanco) => isTipoBancoEqualToEnum(tipoBanco, enums.TipoBanco[key])
  return acc
}, {})
